import { render, staticRenderFns } from "./SSOError.vue?vue&type=template&id=df120c50&scoped=true&"
import script from "./SSOError.vue?vue&type=script&lang=js&"
export * from "./SSOError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df120c50",
  null
  
)

export default component.exports